module.exports = __webpack_public_path__ + "/login_ui/img/sd-979c7eab54c5d58b6ecdefa703899c39.svg";